<template>
  <div class="rightFixed_page" style="color:#000">
     <img style="width:54px" src="@/assets/icon/UI-12.png" alt="">
     <div class="menuBox">
        <a style="cursor: pointer;display: flex;flex-direction: column;align-items: center;" @click="dialogchange">
           <img style="width:32px;" src="@/assets/icon/zixun.png">
           <span style="font-size: 12px;color:#fff">客服</span>
        </a>
        <a  href="/cart" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;">
          <div style="position: relative;height:34px" >
               <img class="right_fixed_car" style="width:36px;margin-left:1px" src="@/assets/icon/shopcar.png">
           <div style="height:10px;min-width:12px;background: red;border-radius: 50%;position: absolute;left:25px;top:8px;text-align: center;line-height: 4px;">
            <span style="color:#fff;font-size: 9px;font-weight: 700;">{{ shopcarNum }}</span>
           </div>
          </div>
           <span style="font-size: 12px;color:#fff;">购物车</span>
        </a>
        <a href="/user" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;">
           <img style="width:36px" src="@/assets/icon/order.png">
           <span style="font-size: 12px;color:#fff;">订单</span>
        </a>
        <a style="cursor: pointer;">
        <el-popover placement="left" :width="300" trigger="click" >
          <template #reference>
            <div style="cursor: pointer;display: flex;flex-direction: column;align-items: center;">
                  <img style="width:23px;" src="@/assets/qas.png">
               <span style="font-size: 12px;color:#fff;margin-top:4px">闪购</span>
            </div>
          </template>
          <div>
            <div style="margin-bottom:10px;width:100%;height:30px;line-height: 30px;text-align: center;background: #0066BA;color:#fff;font-size: 16px;font-weight: 600;"><span>快速订购</span></div>
            <el-form :model="FormData" ref="dynamicValidateForm" class="demo-dynamic" :inline="false">  
              <el-form-item prop="product_code" label="货号" :rules="[
                { required: true, message: '请输入货号', trigger: 'blur' }]">
                <el-input v-model="FormData.product_code" placeholder="请输入货号" ></el-input>
              </el-form-item>
              <el-form-item prop="quantity" label="数量" :rules="[
                { required: true, message: '请输入数量', trigger: 'blur' }]">
                <el-input v-model="FormData.quantity" placeholder="请输入数量" ></el-input>
              </el-form-item>
                <div style="display: flex;justify-content: space-between;width: 100%;">
                  <span style="color:#0066BA;cursor: pointer;font-weight: 700;font-size:14px;display: flex;align-items: center;">
                    <el-icon size="18"><ShoppingCartFull /></el-icon>
                    <span style="margin-left:5px" @click="addCar($event,'dynamicValidateForm')">加入购物车</span></span>
                  <span style="color:#0066BA;cursor: pointer;font-weight: 700" @click="bulkPurchasing">批量订购</span>
                </div>
            </el-form>
          </div>
        </el-popover>
      </a>
        <a href="/bulk" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;margin-top:3px">
           <img style="width:22px" src="@/assets/icon/da.png">
           <div style="font-size: 12px;color:#fff;">大包装<br/><div style="text-align: center;">询价</div></div>
        </a>
     </div>
     <div>
         <el-backtop :bottom="12" :right="16">
            <img style="width:26px;height:26px" src="https://www.meryer.com/resource/images/i_top.png">
        </el-backtop>
     </div>
     <OnlineCustomerService v-model="dialogVisible" :modelValue="dialogVisible"/>
  </div>
</template>

<script setup>
import { ref,computed } from 'vue'
import { ElIcon } from 'element-plus'
import { ElMessage } from 'element-plus';
import { ShoppingCartFull } from '@element-plus/icons-vue'
import api from '@/axios/api'
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useCartAnimation } from '@/components/shopCart'
import OnlineCustomerService from '@/components/OnlineCustomerService.vue'
const { createFlyAnimation } = useCartAnimation()
const route = useRoute()
const router = useRouter()
const store = useStore();
const dialogVisible = ref(false)
const dynamicValidateForm = ref(null)
const FormData = ref({
  product_code:'',
  quantity:''
})

const shopcarNum = computed(() => store.state.shopcartnum);

function dialogchange(){
   dialogVisible.value = true
}

const addCar = (event,formName) => {
  const form = dynamicValidateForm.value
  if (form) {
    form.validate((valid) => {
      if (valid) {
        api.shopCar.cartaddFast(FormData.value).then((res)=>{
          if(res.data.code == 200){
            if(route.path == '/cart'){
              router.go(0)
            }else{
              createFlyAnimation(event.clientX, event.clientY)
              let num = store.state.shopcartnum + +FormData.value.quantity
              store.commit('setshopcartnum', num)             
            }
          } else {
            ElMessage.error(res.data.message)
          }
        })
        // 这里添加实际的搜索逻辑
      } else {
        return false
      }
    })
  }
}

const bulkPurchasing = () => {
  router.push('/multiorder')
}

</script>

<style scoped>
.menuBox{
    width:52px;
    padding:6px 0px;
    /* background: #fff; */
    /* box-shadow: 0px 1px 6px 6px rgba(185, 185, 185, 0.3); */
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
    background: linear-gradient(88deg, 
        #0066BA 0%, 
        #0096CC 65%, 
        /* #0096CC 70%,  */
        #0066BA 100%
      );
    /* background: url(@/assets/icon/UI-13.png) no-repeat center left;
        background-size: 55px 200px; */
}
.menuBox a{
    padding: 4px 0;
    /* border-bottom: 1px solid rgba(225, 225, 225, 0.5); */
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep .el-dialog__body{
   height: 600px;
   overflow: auto;
}
.qq_link span {
    background: url(@/assets/QQ.png) no-repeat center left;
    background-size: 16px 16px;
    padding-left: 17px;
    color:#000;
  
    font-size: 13px;
}
a{
   text-decoration: none;
   padding-top:5px
}
::v-deep .el-tag.el-tag--primary{
   padding:13px !important
}
::v-deep .el-form-item{
  margin-bottom:18px !important
}
::v-deep .el-backtop img{
   width:15px!important;
   height:15px!important
}
::v-deep .el-backtop{
  width:32px !important;
  height:32px !important
}
</style>


